// =========================================================
// DETECCIÓN DEL ENTORNO
// =========================================================
const hostname =
  typeof window !== 'undefined'
    ? window.location.hostname
    : '';

// =========================================================
// PRODUCCIÓN
// =========================================================
const isProduction =
  hostname === 'arcamedic.com' ||
  hostname === 'www.arcamedic.com';

// =========================================================
// REMOTE DEV
// =========================================================
const isRemoteDev =
  process.env.REACT_APP_DEV_REMOTE === 'remote';

// =========================================================
// API
// =========================================================
export const API_BASE_URL =
  isProduction
    ? 'https://arcamedic.com/api/'
    : isRemoteDev
      ? 'https://rsgjzvb0-9999.use2.devtunnels.ms/api/'
      : 'http://localhost:9999/api/';

// =========================================================
// DOWNLOADS
// =========================================================
export const DOWNLOAD_BASE_URL =
  isProduction
    ? 'http://45.166.16.10:8888/download/'
    : 'http://45.166.16.10:8888/download/';

// =========================================================
// AUTH TOKEN
// =========================================================
export const ACCESS_TOKEN_NAME = 'x-auth-token';